import CircularProgress from '@mui/material/CircularProgress';
import styles from './loading.module.scss';

export default function Loading() {
  return (
    <div className={styles.content}>
      <CircularProgress data-testid="LoadingProgress" size={70} color={'primary'} />
    </div>
  );
}
